import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { regions } from '../constants/regions'

const siteEnvironment = import.meta.env.VITE_ENV || (import.meta.env.DEV ? 'development' : 'production')

// 根据环境自动设置默认 region
function getDefaultRegionKey(): string {
  if (siteEnvironment === 'production')
    return 'us' // 生产环境默认美国
  else if (siteEnvironment === 'test' || siteEnvironment === 'preview')
    return 'test' // 测试与预览环境默认远程测试
  else
    return 'dev' // 开发环境默认开发
}

export const useRegionStore = defineStore('region', () => {
  const defaultRegionKey = getDefaultRegionKey()

  // 确保默认值在过滤后的 regions 中存在
  // 如果配置与可用 Region 不一致，使用当前环境里第一个可用 Region。
  const validDefaultKey = regions.some(r => r.envKey === defaultRegionKey)
    ? defaultRegionKey
    : (regions[0]?.envKey ?? defaultRegionKey)

  // 环境由环境变量决定，不使用 localStorage
  // region 的默认值也由环境变量决定，不保存用户选择
  const currentRegionKey = ref(validDefaultKey)

  const currentRegion = computed(() => {
    return regions.find(region => region.envKey === currentRegionKey.value) || regions[0]
  })

  const setRegion = (regionKey: string) => {
    const region = regions.find(r => r.envKey === regionKey)
    if (region) {
      currentRegionKey.value = regionKey
    }
  }

  const getRegionByKey = (regionKey: string) => {
    return regions.find(region => region.envKey === regionKey)
  }

  return {
    currentRegion,
    currentRegionKey,
    regions,
    setRegion,
    getRegionByKey,
  }
})
